export const CAMPAIGN_TAG = 'utm_campaignref';

const appendUtmCampaignRef = (links: NodeListOf<HTMLAnchorElement>, campaignRef: string | null) => {
  links.forEach((link: HTMLAnchorElement) => {
    try {
      const url = new URL(link.href);

      if (campaignRef) {
        url.searchParams.set(CAMPAIGN_TAG, campaignRef);
      }

      link.href = url.toString();
    } catch (error) {
      console.warn(`Skipping invalid link href: ${link.href}. `, error);
    }
  });
};

export const modifyLinksWithUtmCampaignRef = () => {
  const params = new URLSearchParams(window.location.search);

  if (params.has(CAMPAIGN_TAG)) {
    const campaignRef = params.get(CAMPAIGN_TAG);
    const links = document.querySelectorAll('a');

    appendUtmCampaignRef(links, campaignRef);
  }
};
